import cx from 'classnames';
import React, { useRef, useCallback, useState } from 'react';
import Dropdown from 'react-bootstrap/Dropdown';

import { ReactComponent as Dots } from '../../../assets/img/icons/common/Dots.svg';

import { RootPortal } from '../../RootPortal';

import { useHandleOutsideClick } from '../../../hooks/useHandleOutsideClick';

import './TableDropdown.scss';

export const TableDropdown = ({ options, small = false, disabled }) => {
  const dropdownRef = useRef(null);
  const menuRef = useRef(null);
  const [show, setShow] = useState(false);

  const onClickOutside = useCallback(() => {
    setShow(false);
  }, []);

  useHandleOutsideClick(show, onClickOutside, dropdownRef, menuRef);

  return (
    <Dropdown ref={dropdownRef} show={show} className={cx('table-dropdown', { small })}>
      <Dropdown.Toggle
        disabled={disabled}
        onClick={e => {
          e.stopPropagation();
          setShow(prev => !prev);
        }}
      >
        <Dots />
      </Dropdown.Toggle>
      {show && (
        <RootPortal>
          <Dropdown.Menu ref={menuRef}>
            {options
              .filter(option => !option.hidden)
              .map((option, index) => (
                <Dropdown.Item
                  key={index}
                  eventKey={index}
                  disabled={option.disabled}
                  style={{ color: option.color || '#1A1A1A' }}
                  onClick={event => {
                    event.stopPropagation();
                    option.function && option.function(event);
                    setShow(false);
                  }}
                >
                  {option.label}
                </Dropdown.Item>
              ))}
          </Dropdown.Menu>
        </RootPortal>
      )}
    </Dropdown>
  );
};
